export default __webpack_public_path__ + "static/SR USA - OGM - Declaración-df372e14feb9428d0211be1b4391657b.pdf";